import React from 'react';
import { DashStat, StatIcon } from '../salesRepDashboardTypes';
import styles from './StatCard.module.css';

interface StatCardProps {
  stat: DashStat;
}

const icons: Record<StatIcon, React.ReactNode> = {
  sales: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" />
    </svg>
  ),
  customers: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
    </svg>
  ),
  risk: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
  ),
  commission: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
    </svg>
  ),
};

export const StatCard: React.FC<StatCardProps> = ({ stat }) => {
  return (
    <div className={styles.card}>
      <div className={`${styles.iconBox} ${styles[`icon_${stat.color}`]}`}>{icons[stat.icon]}</div>
      <div className={styles.body}>
        <p className={`${styles.value} ${styles[`value_${stat.color}`]}`}>{stat.value}</p>
        <p className={styles.label}>{stat.label}</p>
      </div>
    </div>
  );
};
